@if (
  {
    row: colData | async,
  };
  as $
) {
  <p-popover
    #member
    styleClass="overflow-hidden"
    appendTo="body"
    [dismissable]="true"
  >
    <ng-template #content>
      <!-- Dropdown Content -->
      @if ($.row) {
        <div
          class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2"
        >
          <div class="w-10rem line-height-1 mr-2">
            <div class="text-sm font-medium text-800">
              {{ $.row.full_name }}
            </div>
            <div class="text-xs text-600 mt-1">{{ $.row.id }}</div>
          </div>
          <div [innerHTML]="clientStatus($.row)"></div>
          <!-- <span
        class="bg-blue-50 px-2 py-1 font-bold border-round border-1 border-primary text-primary text-xxs">{{getClientType($.row)| titlecase}}</span> -->
        </div>
      }
      <!-- Dropdown Content -->
      <!-- Dropdown Footer -->
      @if ($.row) {
        <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
          <div class="flex align-items-center mb-2">
            <i class="fa fa-phone mr-2 text-500"></i>
            {{ $.row.mobile_country_code }}{{ $.row.mobile_number }}
          </div>
          <div class="flex align-items-center mb-1">
            <i class="fa fa-envelope font-light mr-2 text-500"></i>
            @if ($.row.email_id) {
              <span class="break-word">
                {{
                  $.row.email_id?.toString().length > 20
                    ? ($.row.email_id | slice: 0 : 20) + '...'
                    : $.row.email_id
                }}</span
              >
            }
            @if (!$.row.email_id) {
              <span>NA</span>
            }
          </div>
        </div>
      }
      <!-- Dropdown Footer -->
    </ng-template>
  </p-popover>
  @if ($.row) {
    <div class="flex align-items-center justify-content-between">
      <span
        class="cursor-pointer flex align-items-center"
        (mouseenter)="member.show($event)"
        (mouseleave)="member.hide()"
        (click)="executeAction('showProfile', $.row)"
      >
        @if (!$.row.image) {
          <p-avatar
            [label]="$.row.full_name | titlecase | shortName"
            shape="circle"
          />
        } @else {
          <p-avatar [image]="$.row.image" shape="circle" />
        }
        <strong class="ml-2 text-primary">
          {{
            $.row.full_name?.toString().length > 20
              ? ($.row.full_name | slice: 0 : 20) + '...'
              : $.row.full_name
          }}
        </strong>
      </span>
      <!-- <span class="bg-blue-50 px-2 py-1 ml-3 border-round border-1 border-primary text-primary text-xxs">MEMBER</span> -->
      @if (showIcon) {
        <div class="flex align-items-center justify-content-end text-sm ml-5">
          @if ($.row?.client_status === 'Client') {
            <i class="fa fa-user text-600 mr-2"></i>
          }
          <span>{{ getClientType($.row) | titlecase }}</span>
        </div>
      } @else {
        @if (showTransferIcon) {
          <div
            class="inline-flex align-items-center justify-content-center h-2rem w-2rem surface-400 border-circle mx-3"
          >
            <i class="fa fa-arrow-right"></i>
          </div>
        }
      }
    </div>
  }
}
